export default "__VITE_ASSET__0f6f2101__"